import { Routes, Route } from 'react-router-dom'
import { Header } from './components/Header'
import { HeroSection } from './components/HeroSection'
import { VideoSection } from './components/VideoSection'
import { FeaturesSection } from './components/FeaturesSection'
import { CTASection } from './components/CTASection'
import { Footer } from './components/Footer'
import { PrivacyPolicy } from './pages/PrivacyPolicy'
import { TermsOfService } from './pages/TermsOfService'
import { GDPR } from './pages/GDPR'
import { Contact } from './pages/Contact'
import { FAQ } from './pages/FAQ'
import { GettingStarted } from './pages/GettingStarted'
import { About } from './pages/About'
import { Pricing } from './pages/Pricing'
import './i18n'

const HomePage = () => (
  <div className="min-h-screen bg-white">
    <Header />
    <main>
      <HeroSection />
      <VideoSection />
      <FeaturesSection />
      <CTASection />
    </main>
    <Footer />
  </div>
)

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/gdpr" element={<GDPR />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/getting-started" element={<GettingStarted />} />
      <Route path="/about" element={<About />} />
    </Routes>
  )
}

export default App